import ArrayField from './ArrayField.js';
import BooleanField from './BooleanField.js';
import FallbackField from './FallbackField.js';
import LayoutGridField from './LayoutGridField.js';
import LayoutHeaderField from './LayoutHeaderField.js';
import LayoutMultiSchemaField from './LayoutMultiSchemaField.js';
import MultiSchemaField from './MultiSchemaField.js';
import NumberField from './NumberField.js';
import ObjectField from './ObjectField.js';
import OptionalDataControlsField from './OptionalDataControlsField.js';
import SchemaField from './SchemaField.js';
import StringField from './StringField.js';
import NullField from './NullField.js';
function fields() {
    return {
        AnyOfField: MultiSchemaField,
        ArrayField: ArrayField,
        // ArrayField falls back to SchemaField if ArraySchemaField is not defined, which it isn't by default
        BooleanField,
        FallbackField,
        LayoutGridField,
        LayoutHeaderField,
        LayoutMultiSchemaField,
        NumberField,
        ObjectField,
        OneOfField: MultiSchemaField,
        OptionalDataControlsField,
        SchemaField,
        StringField,
        NullField,
    };
}
export default fields;
